module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$hydrowareSecurityJS.canView_P('personneljobinfo') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Personnel (Job Info)"
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content pform"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.data.isEdit == false && _vm.$hydrowareSecurityJS.canEdit_P('personneljobinfo')) ? _c('el-button', {
    directives: [{
      name: "ifxx",
      rawName: "v-ifxx",
      value: (!_vm.disableForRoleOrdination && !_vm.isself && _vm.data.isEdit == false && _vm.editShow && _vm.$hydrowareSecurityJS.canEdit_A('personneljobinfo')),
      expression: "!disableForRoleOrdination && !isself && data.isEdit==false && editShow && $hydrowareSecurityJS.canEdit_A('personneljobinfo')"
    }],
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.cEdit
    }
  }, [_c('i', {
    staticClass: "el-icon-edit",
    staticStyle: {
      "font-size": "10px"
    }
  }), _vm._v("\n                Edit\n              ")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.data.isEdit == true && !_vm.disableForRoleOrdination) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    staticStyle: {
      "padding-right": "40px",
      "padding-left": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.modalCancel()
      }
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('el-button', {
    staticClass: "button-blue",
    staticStyle: {
      "padding-right": "40px",
      "padding-left": "40px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.updateJob('jobForm')
      }
    }
  }, [_vm._v("\n              Save\n            ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-xs-12 col-sm-12",
    staticStyle: {
      "padding-left": "inherit"
    }
  }, [_c('el-form', {
    ref: "jobForm",
    attrs: {
      "disabled": !_vm.data['isEdit'] || _vm.disableForRoleOrdination,
      "model": _vm.jobForm,
      "spellcheck": "false"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5",
    staticStyle: {
      "padding-left": "inherit"
    }
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "padding-left": "inherit"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', {
    staticStyle: {
      "color": "#4886C3"
    }
  }, [_vm._v("Job Information")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px solid #DDF3FF"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-5 col-sm-5 col-xs-12",
    staticStyle: {
      "padding-left": "inherit"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Hire Date:",
      "prop": "firstname"
    }
  }, [_c('el-date-picker', {
    staticClass: "hydroware-editNoEdit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "MM-dd-yyyy",
      "type": "date",
      "placeholder": "Hire Date"
    },
    model: {
      value: (_vm.jobForm.HiredOn),
      callback: function($$v) {
        _vm.$set(_vm.jobForm, "HiredOn", $$v)
      },
      expression: "jobForm.HiredOn"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Employee ID:",
      "prop": "lastname"
    }
  }, [_c('el-input', {
    staticClass: "hydroware-editNoEdit",
    attrs: {
      "placeholder": "Employee ID",
      "maxlength": 30
    },
    model: {
      value: (_vm.jobForm.EmployeeId),
      callback: function($$v) {
        _vm.$set(_vm.jobForm, "EmployeeId", $$v)
      },
      expression: "jobForm.EmployeeId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Aquatic Facility:",
      "prop": "gender"
    }
  }, [_c('el-select', {
    staticClass: "hydroware-editNoEdit hydroware hydroware-no-close-select-tag",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select",
      "multiple": ""
    },
    model: {
      value: (_vm.jobForm.LocationId),
      callback: function($$v) {
        _vm.$set(_vm.jobForm, "LocationId", $$v)
      },
      expression: "jobForm.LocationId"
    }
  }, _vm._l((_vm.locations), function(item) {
    return _c('el-option', {
      key: item.LocationId,
      attrs: {
        "label": item.LocationName,
        "value": item.LocationId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.$hydrowareSecurityJS.canView_P('personnelposition')) ? _c('el-form-item', {
    staticClass: "hydroware-no-close-select-tag",
    attrs: {
      "label": "Position:"
    }
  }, [_c('el-select', {
    staticClass: "hydroware-editNoEdit hydroware",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.jobForm.PositionId),
      callback: function($$v) {
        _vm.$set(_vm.jobForm, "PositionId", $$v)
      },
      expression: "jobForm.PositionId"
    }
  }, _vm._l((_vm.positions), function(item) {
    return _c('el-option', {
      key: item.PositionId,
      staticClass: "hydrowarePositionChoice",
      attrs: {
        "disabled": _vm.$hydrowareSecurityJS.disablePositionSelectable_P('edit', item, _vm.personelId),
        "label": item.PositionName,
        "value": item.PositionId
      }
    })
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', {
    staticStyle: {
      "color": "#4886C3",
      "display": "inline"
    }
  }, [_vm._v("Pay Information")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.ViewSalary
    }
  }, [_c('b', [_vm._v("View Salary History")])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px solid #DDF3FF"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Monthly Salary:",
      "prop": "lastname"
    }
  }, [_c('el-input', {
    staticClass: "hydroware-editNoEdit",
    attrs: {
      "type": "number",
      "placeholder": "Monthly Salary",
      "id": "salary"
    },
    model: {
      value: (_vm.jobForm.CurrentSalary),
      callback: function($$v) {
        _vm.$set(_vm.jobForm, "CurrentSalary", $$v)
      },
      expression: "jobForm.CurrentSalary"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Next Pay Change:",
      "prop": "firstname"
    }
  }, [_c('el-date-picker', {
    staticClass: "hydroware-editNoEdit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "MM-dd-yyyy",
      "type": "date",
      "placeholder": "Next Pay Change"
    },
    on: {
      "blur": _vm.hydroware_picker_hasBlurred
    },
    model: {
      value: (_vm.jobForm.NextPayChange),
      callback: function($$v) {
        _vm.$set(_vm.jobForm, "NextPayChange", $$v)
      },
      expression: "jobForm.NextPayChange"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Per Hour Rate:",
      "prop": "lastname"
    }
  }, [_c('el-input', {
    directives: [{
      name: "hydromask",
      rawName: "v-hydromask",
      value: ('###.##'),
      expression: "'###.##'"
    }],
    staticClass: "hydroware-editNoEdit",
    attrs: {
      "type": "text",
      "placeholder": "###.##"
    },
    model: {
      value: (_vm.jobForm.CurrentPayRate),
      callback: function($$v) {
        _vm.$set(_vm.jobForm, "CurrentPayRate", $$v)
      },
      expression: "jobForm.CurrentPayRate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('el-form-item', [(_vm.data['isEdit'] && !_vm.disableForRoleOrdination) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.addSalary
    }
  }, [_vm._v("\n                                Save Pay Change\n                                ")])], 1) : _vm._e()])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-5 col-sm-5 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', {
    staticStyle: {
      "color": "#4886C3"
    }
  }, [_vm._v("\n                      Employment Status\n                    ")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px solid #DDF3FF"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("\n                      Active\n                      "), (_vm.data.isEdit) ? _c('span', [_vm._v("?")]) : _vm._e(), _vm._v(" "), (!_vm.data.isEdit) ? _c('span', [_vm._v("\n                        :\n                        "), (_vm.jobForm.ActiveStatus) ? _c('span', [_vm._v("Yes")]) : _vm._e(), _vm._v(" "), (!_vm.jobForm.ActiveStatus) ? _c('span', [_vm._v("No")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.data.isEdit) ? _c('el-switch', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "disabled": _vm.disableForRoleOrdination,
      "on-color": "#13ce66",
      "off-color": "#ff4949",
      "on-text": "Yes",
      "off-text": "No"
    },
    model: {
      value: (_vm.jobForm.ActiveStatus),
      callback: function($$v) {
        _vm.$set(_vm.jobForm, "ActiveStatus", $$v)
      },
      expression: "jobForm.ActiveStatus"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [(!_vm.data.isEdit && !_vm.jobForm.ActiveStatus && !_vm.jobForm.ActiveStatus) ? _c('label', {
    staticClass: "el-form-item__label"
  }, [_c('span', {
    staticStyle: {
      "opacity": "0.7"
    }
  }, [_vm._v("\n                        Terminated: \n                        "), _c('span', [_vm._v("\n                          " + _vm._s(_vm.jobForm.TerminatedStatus ? 'Yes' : 'No') + " \n                        ")])])]) : _vm._e(), _vm._v(" "), (_vm.data.isEdit) ? _c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("Terminated? ")]) : _vm._e(), _vm._v(" "), (_vm.data.isEdit) ? _c('el-switch', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "disabled": _vm.disableForRoleOrdination || _vm.jobForm.ActiveStatus,
      "on-color": "#13ce66",
      "off-color": "#ff4949",
      "on-text": "Yes",
      "off-text": "No"
    },
    model: {
      value: (_vm.jobForm.TerminatedStatus),
      callback: function($$v) {
        _vm.$set(_vm.jobForm, "TerminatedStatus", $$v)
      },
      expression: "jobForm.TerminatedStatus"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jobForm.TerminatedStatus && !_vm.jobForm.ActiveStatus),
      expression: "jobForm.TerminatedStatus  && !jobForm.ActiveStatus"
    }],
    staticClass: "col-lg-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jobForm.TerminatedStatus && _vm.data.isEdit && !_vm.jobForm.ActiveStatus),
      expression: "jobForm.TerminatedStatus &&  data.isEdit && !jobForm.ActiveStatus"
    }],
    staticClass: "col-lg-12",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('h3', {
    staticStyle: {
      "color": "#4886C3",
      "font-size": "1.6em",
      "padding-top": "10px"
    }
  }, [_vm._v("\n                      Termination Information\n                    ")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px solid #DDF3FF"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Terminated By:",
      "prop": "address"
    }
  }, [_c('el-select', {
    staticClass: "hydroware-editNoEdit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.disableForRoleOrdination,
      "placeholder": "Select"
    },
    model: {
      value: (_vm.jobForm.TerminatedBy),
      callback: function($$v) {
        _vm.$set(_vm.jobForm, "TerminatedBy", $$v)
      },
      expression: "jobForm.TerminatedBy"
    }
  }, _vm._l((_vm.users), function(item) {
    return _c('el-option', {
      key: item.UserName,
      attrs: {
        "label": item.Name,
        "value": item.UserName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Termination Date:",
      "prop": "address"
    }
  }, [_c('el-date-picker', {
    staticClass: "hydroware-editNoEdit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.disableForRoleOrdination,
      "format": "MM-dd-yyyy",
      "type": "date",
      "placeholder": "Termination Date"
    },
    on: {
      "blur": _vm.hydroware_picker_hasBlurred
    },
    model: {
      value: (_vm.jobForm.TerminationDate),
      callback: function($$v) {
        _vm.$set(_vm.jobForm, "TerminationDate", $$v)
      },
      expression: "jobForm.TerminationDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Termination Reason:",
      "prop": "gender"
    }
  }, [_c('el-input', {
    staticClass: "hydroware-editNoEdit",
    attrs: {
      "type": "textarea",
      "disabled": _vm.disableForRoleOrdination,
      "rows": 6,
      "maxlength": 400,
      "placeholder": "Notes"
    },
    model: {
      value: (_vm.jobForm.TerminationReason),
      callback: function($$v) {
        _vm.$set(_vm.jobForm, "TerminationReason", $$v)
      },
      expression: "jobForm.TerminationReason"
    }
  })], 1)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.data.isEdit == false && _vm.$hydrowareSecurityJS.canEdit_P('personneljobinfo')) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.cEdit
    }
  }, [_c('i', {
    staticClass: "el-icon-edit",
    staticStyle: {
      "font-size": "10px"
    }
  }), _vm._v("\n                Edit\n              ")]) : _vm._e()], 1), _vm._v(" "), (_vm.data.isEdit == true && !_vm.disableForRoleOrdination) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    staticStyle: {
      "padding-right": "40px",
      "padding-left": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.modalCancel()
      }
    }
  }, [_vm._v("\n                Cancel\n              ")]), _vm._v(" "), _c('el-button', {
    staticClass: "button-blue",
    staticStyle: {
      "padding-right": "40px",
      "padding-left": "40px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.updateJob('jobForm')
      }
    }
  }, [_vm._v("\n                Save\n              ")])], 1) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "ViewSalary",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog ",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.salaries), function(salary) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm._f("fdate")(salary.PayFrom)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm._f("fdate")(salary.PayTo)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(salary.PayRate ? '$' + salary.PayRate : ''))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(salary.Salary ? '$' + salary.Salary : ''))])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "background-color": "#6DC8F4",
      "border-radius": "inherit"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center",
      "color": "white"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('h3', [_vm._v("Pay History")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Per Hour Rate")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Monthly Salary")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e0083f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Jobdetails/Jobdetails.vue
// module id = 819
// module chunks = 1